import { browserHistory } from "./../../App";
import reduxStore from "./../../redux/configureStore";
import { setBosServerUnavailable } from "../../redux/actions/appStateActions";

export const POST_METHOD = "post";
export const GET_METHOD = "get";

export function getDefaultJsonHeaders() {
  return {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };
}

export function getDefaultJsonHeadersWithAuthentication(token) {
  return {
    ...getDefaultJsonHeaders(),
    "Authorization": "Bearer " + token
  };
}

export function getDefaultJsonHeadersWithSession(sessionId) {
  return {
    ...getDefaultJsonHeaders(),
    "SessionId": sessionId
  };
}

export function getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId) {
  return {
    ...getDefaultJsonHeadersWithAuthentication(token),
    "SessionId": sessionId
  };
}

export function setBosServerUnavailableAndRethrow(error) {
  console.log("Setting Bos Server unavailable to", true);
  setBosServerUnavailable_(true);
  handleError(error, false);
}

export function setBosServerAvailable(res) {
  setBosServerUnavailable_(false);
  return res;
}

export function checkStatus(res) {
  console.log("checkStatus res", res);
  if (res.ok) return res;
  if (res.status === 401) redirectUnauthorized();
  handleError(res.statusText);
}

export function checkDefaultErrorMessage(jsonOrText, onlyLogError = true) {
  if (jsonOrText && jsonOrText.toString().startsWith("ERROR:")) handleError(jsonOrText, onlyLogError);
  if (jsonOrText && jsonOrText.errorMessage) handleError(jsonOrText.errorMessage, onlyLogError);
  return jsonOrText;
}

const redirectUnauthorized = () => {
  browserHistory.push("/logout/-1");
};

const setBosServerUnavailable_ = (unavailable) => {
  if (reduxStore.getState().appState.bosServerUnavailable === unavailable) return;
  reduxStore.dispatch(setBosServerUnavailable(unavailable));
};

const handleError = (error, onlyLog = true) => {
  if (onlyLog) console.error("Error: ", error);
  else throw new Error(error);
};

export function toParamString(allParams) {
  return allParams.join("/");
}

export function toSaveValue(value) {
  return (value === null || value === undefined) ? "null" : value;
}

export function encodeBosUri(uri) {
  return uri.split("/").join(":");
}

export function timeoutSignal(timeoutInMS) {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), timeoutInMS);
  return controller.signal;
}
